import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {FIRST_TIME_CHANGE_PASSWORD_URL, LOGIN_URL} from '../config/url-config'

import {
    ERR_MSG,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES,
    FIRST_TIME_CHANGE_PASSWORD_105,
    FIRST_TIME_CHANGE_PASSWORD_101,
    FIRST_TIME_CHANGE_PASSWORD_103,

    FIRST_TIME_CHANGE_PASSWORD_104,
    FIRST_TIME_CHANGE_PASSWORD_102,
    CNG_PWD_POLICY_ERR,
    CHG_PWD_POLICY_ERR,
    FIRST_TIME_CHANGE_PASSWORD_106,
    FIRST_TIME_CHANGE_PASSWORD_107
} from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {scanBarResponseStatus} from "./mfaverifytokenservice";
import {extractStatusCode} from "../helper/responsehelper";

export const changePasswordStatus = {
    [FIRST_TIME_CHANGE_PASSWORD_101]:ERR_MSG,
    [FIRST_TIME_CHANGE_PASSWORD_102]:SESS_EXPIRED_TEXT,
    [FIRST_TIME_CHANGE_PASSWORD_103]: ERR_MSG,
    [FIRST_TIME_CHANGE_PASSWORD_104]: ERR_MSG,
    [FIRST_TIME_CHANGE_PASSWORD_105]:SESS_EXPIRED_TEXT,
    [FIRST_TIME_CHANGE_PASSWORD_106]:CHG_PWD_POLICY_ERR,
    [FIRST_TIME_CHANGE_PASSWORD_107]: SESS_EXPIRED_TEXT,
    "UNK-ERR-102": ERR_MSG,
};
const constructFirstTimeChangePassword = (formFields,session)=>(
    {
        session:session,
        newPassword:get(formFields,"newPassword"),
        userName:get(formFields,"userName")
    }
)
export const firstTimeChangePasswordService = (formFields,session)=>{
    const changePaswordRequest = constructFirstTimeChangePassword(formFields,session)

    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(FIRST_TIME_CHANGE_PASSWORD_URL(),changePaswordRequest)
            .then((response) => {

                let statusCode =extractStatusCode(response);
                console.log("change statusCode",statusCode)
                if(SUCCESS_CODES.FIRST_TIME_CHANGE_PASSWORD.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = changePasswordStatus[statusCode]
                    console.log("errText",errText)
                    console.log("SESS_EXPIRED",SESS_EXPIRED_TEXT)
                    console.log("errText === SESS_EXPIRED",errText === SESS_EXPIRED_TEXT)
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}